import { useConversationQuery } from '@shared/generated/graphql';
import { conversationFromFragment } from '@shared/graphql/fromFragments/conversation';
import { Conversation } from '@shared/types/conversation';

type UseConversationOptions = {
  id: string;
  pollIntervalMs?: number;
  skip?: boolean;
};

type UseConversationState = {
  conversation: Conversation | null;
  isLoading: boolean;
  refetch: () => Promise<void>;
};

export type UseConversationValue = UseConversationState;

export const useConversation = (
  props: UseConversationOptions
): UseConversationValue => {
  const { id, pollIntervalMs, skip } = props;
  const { data, loading, refetch } = useConversationQuery({
    variables: { id },
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-first',
    pollInterval: pollIntervalMs,
    skip: skip || !id,
  });

  const conversation = data?.conversationById
    ? conversationFromFragment(data.conversationById)
    : null;

  return {
    conversation,
    isLoading: loading,
    refetch: async () => {
      await refetch();
    },
  };
};
